import React from "react";
import AcademyLogo from "../../../../assets/img/png/academy-logo.png";

import "./PresentationCourses.scss";

export default function PresentationCourses() {
  return (
    <div className="presentation-courses">
      <img src={AcademyLogo} alt="Cursos más populares en Udemy" />
      <p>
        En Udemy vas a encontrar los mejores cursos online de desarrollo web en
        Español. Unete y empieza tu camino como Desarrodor Web, Aplicaciones
        Moviles, Base de Datos, Testing de Software, Ciencias de la Información
        y etc. Sinceramente, estos curso es el tipo de contenido que a mi me
        hubiera gustado encontrar cuando empecé en el mundo del desarrollo web
        profesional.
      </p>
      <p>¡¡¡Échales un vistazo y aprovecha las ofertas!!!</p>
    </div>
  );
}
